import { createContext, useContext } from 'react';
import { RecordType } from '@xbcb/shared-types';

export interface AppRecordContextValue {
  recordId: string;
  recordType: RecordType | null;
  updateLoading: boolean;
  taskActivelyInProgress: boolean;
}

export const defaultValues = {
  recordId: '',
  recordType: null,
  updateLoading: false,
  taskActivelyInProgress: false,
};

export const AppRecordContext =
  createContext<AppRecordContextValue>(defaultValues);

export const useAppRecordContext = (): AppRecordContextValue => {
  const { recordId, recordType, updateLoading, taskActivelyInProgress } =
    useContext(AppRecordContext);
  return {
    recordId,
    recordType,
    updateLoading, // The save button has been pressed; all actions disabled while update mutation is in flight
    taskActivelyInProgress,
  };
};
